
import React from "react";
import { i18nManager } from "../../../../i18n";
import { Siren } from "../../../shared/ConfirmDialog";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, ITeam, ITeamWebsite, MemberService, SanitizedResponse, TeamService } from "../../../../services";
import PageDesign from "../../../page_design/PageDesign";
import { Capability } from "../../../../utils";

export interface DesignProps {
    team: ITeam;
    profile: IMember;
    teamWebsite: ITeamWebsite;
}

function Design(props: DesignProps) {

    const teamService = TeamService.getInstance();
    const [teamWebsite, setTeamWebsite] = React.useState<ITeamWebsite>(props.teamWebsite);

    return (<div className="profile-settings team-settings"><PageDesign capability={Capability.CHANGE_TEAM_WEBSITE_DESIGN} publicId={props.team.public_id} designType={"team"} activeDesign={teamWebsite.design_settings} onUpdate={updateDesign} planLevel={BaseService.getPlanCode(teamWebsite.extra_data?.owner_plan ?? props.profile.plan)} /></div>);

    function updateDesign(pageDesign: any, onDone?: () => void) {
        if (!teamWebsite) return onDone?.();
        teamWebsite.design_settings = pageDesign;
        teamService.updateTeamWebsite(props.team.external_id, { ...teamWebsite }).then(({ sanitized }: SanitizedResponse<ITeamWebsite>) => {
            setTeamWebsite(sanitized);
            Siren.alert(i18nManager.Labels.teams.settings.website.design_update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Design;
